<div class="card">
  <div class="card-body">

    <form class="row d-flex flex-column align-items-center justify-content-center" (ngSubmit)="LoadCollection()">
      <div class="d-flex flex-column flex-md-row justify-content-between w-100">
        <div class="d-flex flex-column justify-content-between">          
          <div class="fieldset">
            <label class="legend">Course</label>
            <select (change)="filterByModuleAction($event.target.value)" class="text-field">
              <option *ngFor="let module of moduleFilterActions" [value]="module.params.id">{{module.displaytext}}</option>
            </select>           
          </div>
          <div class="fieldset" *ngIf="allowBatches">
            <label class="legend">Batch</label>
            <select class="text-field" (change)="filterByBatch($event.target.value)" >
              <option *ngFor="let batch of batchFilterActions" [value]="batch.params.id">{{batch.displaytext}}</option>
            </select>           
          </div>          
        </div>      
        <div>
          <div class="fieldset">
            <label class="legend" for="price">From Date</label>
            <input type="datetime-local" [(ngModel)]="fromDate" name="fromDate" class="text-field" id="fromDate">
          </div>
          <div class="fieldset">
            <label class="legend" for="price">To Date</label>
            <input type="datetime-local" [(ngModel)]="toDate" name="toDate" class="text-field" id="toDate">
          </div>
        </div>        
        <div class="fieldset fieldset--lg m-0 p-0" id="searchcontainer">
          <label class="legend" for="price">Search</label>
          <input type="text" [(ngModel)]="searchText" name="searchText" class="text-field w-10" id="searchText">
        </div>  
      </div>                          
      <button type="submit" class="btn btn-primary mx-auto my-3">Filter</button>
    </form>

    <div class="table-responsive">
      <table class="table align-items-center table-flush table-hover">
        <thead class="thead-light">
          <tr>
            <th class="handCursor" (click)="changeSort('Count')"> S/N (Count: {{this.util.numberWithCommas(count)}})
              <i *ngIf="sortBy == 'Count' && sortAsc" class="ml-1 fas fa-caret-up"></i> <i
                *ngIf="sortBy == 'Count' && !sortAsc" class="ml-1 fas fa-caret-down"></i>
            </th>
            <th class="handCursor" (click)="changeSort('Date')"> Date <i *ngIf="sortBy == 'Date' && sortAsc"
                class="ml-1 fas fa-caret-up"></i> <i *ngIf="sortBy == 'Date' && !sortAsc"
                class="ml-1 fas fa-caret-down"></i></th>
            <th class="handCursor" (click)="changeSort('Paid')"> Paid <i *ngIf="sortBy == 'Paid' && sortAsc"
                class="ml-1 fas fa-caret-up"></i> <i *ngIf="sortBy == 'Paid' && !sortAsc"
                class="ml-1 fas fa-caret-down"></i></th>
            <th class="handCursor" (click)="changeSort('Package')"> Package <i *ngIf="sortBy == 'Package' && sortAsc"
                class="ml-1 fas fa-caret-up"></i> <i *ngIf="sortBy == 'Package' && !sortAsc"
                class="ml-1 fas fa-caret-down"></i></th>
            <th class="handCursor" (click)="changeSort('Module')"> Course <i *ngIf="sortBy == 'Module' && sortAsc"
                class="ml-1 fas fa-caret-up"></i> <i *ngIf="sortBy == 'Module' && !sortAsc"
                class="ml-1 fas fa-caret-down"></i></th>
            <th class="handCursor" (click)="changeSort('Amount')"> Amount <i *ngIf="sortBy == 'Amount' && sortAsc"
                class="ml-1 fas fa-caret-up"></i> <i *ngIf="sortBy == 'Amount' && !sortAsc"
                class="ml-1 fas fa-caret-down"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of collectionData">
            <td>{{item.position}}</td>
            <td>{{item.dateString}}</td>
            <td>
              <span *ngIf="item.paid"><i class="mr-3 fa fa-check-circle text-green"></i> Paid </span>
              <span *ngIf="!item.paid"><i class="mr-3 fa fa-times-circle text-red"></i> Unpaid</span>
            </td>
            <td>{{item.packageName}}</td>
            <td>{{item.moduleName}}</td>
            <td class="text-center">₦{{this.util.numberWithCommas(item.amount)}}</td>

          </tr>
        </tbody>
        <tfoot>
          <tr>
            <!-- <th colspan="5" class="text-right"> PerPage:
              <select name="">
                <option *ngFor="let item of collectionData;" value="50">50</option>
              </select>
            </th> -->
            <th colspan="5" class="text-right"> Total : </th>
            <th class="text-center">₦{{this.util.numberWithCommas(total)}}</th>
          </tr>
        </tfoot>
      </table>
      <table>
        <tr colspan="2" *ngIf="collectionData.length>0" class="border-top-0">
          <td class="text-right border-top-0"> Per Page:
            <select [value]="item" [(ngModel)]="perPage" name="perPage" class="mr-1" (change)="changePerpage(event)">
              <option *ngFor="let item of Pages;">{{item}}
              </option>
            </select>
            <button class="ml-2" (click)="getPageData(item)" *ngFor="let item of numberButtons;"
              [ngStyle]="getButtonColor(item)">{{item}}</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>